import axios from "axios";

export const exportDataWithToken = async (url, token, fileName = "export_data.xlsx") => {
    if (!token) {
        console.error("Export failed: missing auth token.");
        if (window.swal) {
            window.swal({
                title: "Export Failed",
                text: "Authentication token is missing. Please log in again and try.",
                icon: "error",
            });
        }
        return;
    }

    try {
        const response = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            responseType: "blob", // Important for handling binary data
        });

        // Create a URL for the blob
        const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = urlBlob;
        link.setAttribute("download", fileName); // Set the file name
        document.body.appendChild(link);
        link.click();

        // Clean up
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(urlBlob);

        // Show success message
        if (window.swal) {
            window.swal({
                title: "Export Successful",
                text: `${fileName} has been downloaded.`,
                icon: "success",
                button: false,
                timer: 2000,
            });
        }
    } catch (error) {
        console.error("Error exporting data:", error);
        if (window.swal) {
            const errorText = error?.response?.data?.message || "An error occurred while exporting data. Please try again.";
            window.swal({
                title: "Export Failed",
                text: errorText,
                icon: "error",
            });
        }
    }
};
